var DefaultInputProps = /** @class */ (function () {
    function DefaultInputProps() {
    }
    return DefaultInputProps;
}());
export { DefaultInputProps };
